import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SearchFilterPipe } from './search-filter.pipe';
import { SearchTextPipe } from './searchText.pipe';
import { DateAgoPipe } from './date-ago.pipe';
import { ReplaceNullValuePipe } from './replace-null-value.pipe';
import { ShortenPipe } from './shorten.pipe';
import { AbbreviateNumberPipe } from './abbreviate-number.pipe';
import { ParseMarkdownPipe } from './parse-markdown.pipe';
import { LineClampTextPipe } from './line-clamp-text.pipe';

@NgModule({
  declarations: [SearchFilterPipe, SearchTextPipe, DateAgoPipe, ReplaceNullValuePipe, ShortenPipe, AbbreviateNumberPipe, ParseMarkdownPipe, LineClampTextPipe],
  imports: [
    CommonModule,
  ],
  providers:[DateAgoPipe, ReplaceNullValuePipe, ParseMarkdownPipe],
  exports: [SearchFilterPipe, SearchTextPipe, DateAgoPipe, ReplaceNullValuePipe, ShortenPipe, AbbreviateNumberPipe, ParseMarkdownPipe, LineClampTextPipe]
})
export class AppPipesModule { }
